import React from "react";

import MuiAccordionDetails from "@mui/material/AccordionDetails";
import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import RuiAccordion, {
  AccordionSummary,
  AccordionSummaryProps,
} from "@rui/Accordion";
import Stack from "@rui/Stack";

export const Accordion = styled(RuiAccordion)(({ theme }) => ({
  borderRadius: "0 !important",
  "&:not(:last-of-type)": {
    borderBottom: "1px solid",
    borderColor: theme.palette.shades.neutral[100],
  },
}));

export const AccordionHeader = styled<React.FC<AccordionSummaryProps>>(
  (props) => <AccordionSummary {...props} iconSize="24px" />
)(({ theme }) => ({
  minHeight: "40px",
  border: "none",
  padding: 0,
  borderRadius: 0,
  "& .MuiAccordionSummary-expandIconWrapper": {
    marginRight: theme.spacing(0.5),
  },
  "& .MuiAccordionSummary-content": {
    alignItems: "center",
    columnGap: "8px",
    margin: theme.spacing(2, 0),
    overflow: "hidden",
  },
}));

export const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(0, 0, 2),
}));

export const ThreadHeading = styled(Typography)(({ theme }) => ({
  ...theme.typography.bodySecondaryMed,
  fontWeight: 600,
  fontFamily: theme.typography.fontFamilySecondary,
}));

export const ImgContainer = styled(Stack)(({ theme }) => ({
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "12px",
  border: "1px solid",
  borderColor: theme.palette.shades.neutral[100],
  padding: theme.spacing(0.5),
  backgroundColor: theme.palette.transparent.white[40],
  flexShrink: 0,
}));

export const CitationWrapper = styled(Stack)(({ theme, onClick }) => ({
  transition: "all 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
  padding: theme.spacing(1.5),
  backgroundColor: theme.palette.transparent.black[4],
  border: "1px solid",
  borderColor: "transparent",
  borderRadius: "2px 16px 16px 16px",
  "& .open-citation__link-label": {
    display: "none",
  },
  "&.spotlight": {
    backgroundColor: "#FFF",
    borderColor: theme.palette.shades.primary[700],
    "& .open-citation__link-label": {
      display: "inline",
    },
  },
  "&:hover": {
    ...(onClick && { cursor: "pointer" }),
    backgroundColor: "#FFF",
    borderColor: theme.palette.shades.primary[600],
    "& .open-citation__link-label": {
      display: "inline",
    },
  },
}));

export const CitationText = styled(Typography)(({ theme }) => ({
  ...theme.typography.bodySecondaryReg,
  fontFamily: theme.typography.fontFamilySecondary,
  lineHeight: 21 / 14,
}));

export const DetailText = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamilySecondary,
  fontSize: "0.75rem",
  color: theme.palette.shades.neutral[500],
}));
